import { getAlternateElements } from '../shared/utils';
import { getRegionElements } from '../shared/utils';

const siteSelectorLinkSelector = '.top-menu__siteselector-v3__list__link';

const getAlternateDomains = (): { href: string; hreflang: string }[] => {
  return Array.prototype.map.call(
    getAlternateElements(),
    (x: HTMLLinkElement) => ({ href: x.href, hreflang: x.hreflang })
  );
};

const getRegionDomains = (): { regionCode: string; href: string }[] => {
  return Array.prototype.map.call(
    getRegionElements(),
    (x: HTMLMetaElement) => ({ regionCode: x.name, href: x.content })
  );
};

const findAlternateDomainByHrefLang = (
  alternateDomains: { href: string; hreflang: string }[],
  _href: string,
  hreflang: string
): string | null => {
  return alternateDomains.filter((x: { href: string; hreflang: string }) => {
    return x.hreflang === hreflang.toLowerCase();
  })[0]?.href;
};

const findAlternateDomain = (href: string, hreflang: string): string | null => {
  const alternateDomains = getAlternateDomains();
  return (
    findAlternateDomainByHrefLang(alternateDomains, href, hreflang) ??
    findRegionDomain(hreflang) ??
    findAlternateDomainByHrefLang(alternateDomains, href, 'x-default')
  );
};

const findRegionDomain = (hreflang: string): string | null => {
  const regionDomains = getRegionDomains();
  const matchingDomain = regionDomains.find(
    (x) => x.regionCode.toLowerCase() === `region-${hreflang.toLowerCase()}`
  );

  return matchingDomain?.href || null;
};

window.addEventListener('DOMContentLoaded', () => {
  const alternateElements: NodeListOf<HTMLLinkElement> = getAlternateElements();
  if (alternateElements.length === 0) {
    // No alternates, not persistance (No money, no honey).
    return;
  }

  const siteSelectorLinks: NodeListOf<HTMLAnchorElement> =
    document.querySelectorAll(siteSelectorLinkSelector);

  Array.prototype.forEach.call(
    siteSelectorLinks,
    (siteSelectorLink: HTMLAnchorElement) => {
      const { href, hreflang } = siteSelectorLink;
      const { search } = location;

      const relatedAlternateHref: string | null = findAlternateDomain(
        href,
        hreflang
      );

      if (!relatedAlternateHref) {
        return;
      }

      siteSelectorLink.href = `${relatedAlternateHref}${search}`;
    }
  );
});
